var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCodeImageBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16618 1.16618H4.6647V0H0V4.6647H1.16618V1.16618Z",
    fill: "#2C3E50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2812 0V1.16618H18.82V4.6647H19.9996V0H15.2812Z",
    fill: "#2C3E50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.82 18.82H15.2812V19.9996H19.9996V15.2812H18.82V18.82Z",
    fill: "#2C3E50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16618 15.2812H0V19.9996H4.6647V18.82H1.16618V15.2812Z",
    fill: "#2C3E50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35938 2.36133V8.20561H8.2126V4.69904H9.38324V3.53018H8.2126V2.36133H2.35938ZM7.04195 7.03675H3.53002V3.53018H7.04195V7.03675Z",
    fill: "#2C3E50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5859 17.5864V11.7331H15.2446V10.5625H14.0739V11.7331H10.562V12.9038H11.7327V14.0744H10.562V15.2451H11.7327V17.5864H17.5859ZM12.9033 12.9038H16.4152V16.4157H12.9033V12.9038Z",
    fill: "#2C3E50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87514 10.5567H8.21898V9.38477H2.35938V10.5567H4.70322V11.7286H3.5313V12.9005H4.70322V15.2444H3.5313V16.4163H4.70322V17.5882H10.5628V16.4163H9.3909V15.2444H8.21898V16.4163H5.87514V15.2444H7.04706V14.0724H5.87514V10.5567Z",
    fill: "#2C3E50"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71729 4.66602H5.89687V5.8456H4.71729V4.66602Z",
    fill: "#2C3E50"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1021 4.66602H15.2816V5.8456H14.1021V4.66602Z",
    fill: "#2C3E50"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2492 8.21455H17.587V2.36133H11.7427V8.21455H14.0804V9.38519H15.2492V8.21455ZM12.9115 7.0439V3.53197H16.4181V7.0439H12.9115Z",
    fill: "#2C3E50"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5868 10.5643V9.38477C17.3079 9.38477 15.5621 9.38477 15.2812 9.38477V10.5643H17.5868Z",
    fill: "#2C3E50"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1021 14.0469H15.2816V15.2265H14.1021V14.0469Z",
    fill: "#2C3E50"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38379 12.8691H10.5634V14.0487H9.38379V12.8691Z",
    fill: "#2C3E50"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07861 14.0486H8.25819C8.25819 13.7632 8.25819 11.9768 8.25819 11.6895H7.07861V14.0486Z",
    fill: "#2C3E50"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25684 10.5625H9.3828V11.6885H8.25684V10.5625Z",
    fill: "#2C3E50"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53896 12.8691H2.35938V15.2283H3.53896C3.53896 14.9429 3.53896 13.1565 3.53896 12.8691Z",
    fill: "#2C3E50"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35938 16.4062H3.53896V17.5858H2.35938V16.4062Z",
    fill: "#2C3E50"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38379 2.36133H10.5634V3.54091H9.38379V2.36133Z",
    fill: "#2C3E50"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38379 7.02518H10.5634C10.5634 6.7398 10.5634 4.95338 10.5634 4.66602H9.38379V7.02518Z",
    fill: "#2C3E50"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5634 9.38271V8.20312H9.38379V10.5623H14.1021V9.38271H10.5634Z",
    fill: "#2C3E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeImageBlue);
export default __webpack_public_path__ + "static/media/qr-code-image-blue.d458102487ba7f1c50fd890c9dd579ae.svg";
export { ForwardRef as ReactComponent };